const MINUTES_IN_DAY = 60 * 24;

export default {
  methods: {
    getDuration(from, to) {
      if (!from || !to) {
        return 0;
      }

      const minFrom = this.timeStringToMinutes(from);
      const minTo = this.timeStringToMinutes(to) || MINUTES_IN_DAY;
      const diff = minTo - minFrom;
      const hh = (diff / 60) | 0;
      const mm = diff % 60;

      return `${hh}h ${mm}m`;
    },

    timeStringToMinutes(time) {
      const [hh, mm] = time.split(':');

      return parseInt(hh) * 60 + parseInt(mm);
    }
  }
};
